import { CSSProperties } from "react";

interface CountryFlagProps {
    countryCode?: string;
    title?: string;
    style?: CSSProperties;
    className?: string;
    svg?: boolean;
}

const toFlagEmoji = (countryCode?: string) => {
    const isoCode = countryCode?.trim().toUpperCase();

    if (!isoCode || !/^[A-Z]{2}$/.test(isoCode)) {
        return undefined;
    }

    return String.fromCodePoint(
        ...Array.from(isoCode, character => character.codePointAt(0)! + 127397)
    );
};

export const CountryFlag = ({
    countryCode,
    title,
    style,
    className,
}: CountryFlagProps) => {
    const flag = toFlagEmoji(countryCode);

    return (
        <span
            className={className}
            role="img"
            aria-label={title || (flag ? countryCode?.toUpperCase() : "Country not available")}
            title={title}
            style={{
                display: "inline-block",
                fontSize: "1.25rem",
                lineHeight: 1,
                verticalAlign: "middle",
                ...style,
            }}
        >
            {flag ?? "🌐"}
        </span>
    );
};
